export const dataMistakesModalMessageSelector = (state) => state.chat.dataMistakesModalMessage;
